export class Messages {
  static readonly duplicatePatientTitle = 'Pacient deja înregistrat';

  static duplicatePatientDescription(cnp: string): string {
    return `Pacientul cu CNP ${cnp} este deja înregistrat în sistem.`;
  }

  static readonly takeoverPatientAction = 'Preia pacient';
  static readonly closeAction = 'Închide';
}
